import { queryOptions } from '@tanstack/vue-query'
import { fetch } from './api/fetchRegions'
import { fetchProviders } from './api/fetchUtilityProvider'
import { fetchTariffNames } from './api/fetchtariffNames'
import { fetchTariffs } from './api/fetchTariffs'
import { fetchTariffYears } from './api/fetchTariffYears'
import { type MaybeRefOrGetter, toValue } from 'vue'
import { fetchTOUProfile } from './api/fetchTOUProfiles'
import { fetchAssetTariffDashboard } from './api/fetchAssetTariffsDashboard'
import type { PaginationParameters } from '@/composables/query-parameters'

export const filterQueries = {
  fetchRegion: () => ({
    queryKey: ['regions'],
    queryFn: () => fetch(),
    meta: {
      logger: 'features/tariffs/fetchRegion'
    },
  }),

  fetchProviders: (region?: MaybeRefOrGetter<number[]>) => queryOptions({
    queryKey: ['providers',region],
    queryFn: () => fetchProviders(toValue(region)),
    meta: {
      logger: 'features/tariffs/fetchProviders'
    }
  }),

  fetchTariffNames: (providers: MaybeRefOrGetter<number[]>) => queryOptions({
    queryKey: ['tariffNames', providers],
    queryFn: () => fetchTariffNames(toValue(providers)),
    enabled: () => {
      const val = toValue(providers)
      return Array.isArray(val) && val.length > 0
    },
    meta: {
      logger: 'features/tariffs/fetchTariffNames'
    }
  }),

  fetchTariffYears: (ids: MaybeRefOrGetter<number[]>) => queryOptions({
    queryKey: ['years', ids],
    queryFn: () => fetchTariffYears(toValue(ids)),
    enabled: () => {
      const val = toValue(ids)
      return Array.isArray(val) && val.length > 0
    },
    meta: {
      logger: 'features/tariffs/fetchTariffYears'
    }
  })
} as const

export const mainQueries = {
  fetchTariffs: (ids: MaybeRefOrGetter<number[]>, yearOfTariff: MaybeRefOrGetter<string>) => queryOptions({
    queryKey: ['tariffs', ids, yearOfTariff],
    queryFn: () => fetchTariffs(toValue(ids), toValue(yearOfTariff)),
    meta: {
      logger: 'features/tariffs/fetchTariffs'
    }
  }),

  fetchTOUProfile: (id: MaybeRefOrGetter<number>) => queryOptions({
    queryKey: ['touProfiles',id],
    queryFn: () => fetchTOUProfile(toValue(id)),
    enabled: () => {
      const val = toValue(id)
      return val > 0
    },
    meta: {
      logger: 'features/tariffs/TOUProfile'
    }
  }),

  fetchAssetTariffDashboard: (params: PaginationParameters) => queryOptions({
    queryKey: ['assetTariffDashboard', params],
    queryFn: () => fetchAssetTariffDashboard({
      page: toValue(params.page),
      pageSize: toValue(params.pageSize),
    }),
    meta: {
      logger: 'features/tariffs/AssetTariffDashboard'
    }
  })
}
